import * as React from "react";
import DebtSvg from "src/assets/debt.svg";
import DataMissing from "src/components/general/DataMissing";
import axios from "axios";
import { baseUrl } from "src/constants/ApiSettings";
import { ICouncil } from "src/interfaces";
import * as qs from "query-string-for-all";
import CouncilIdentityBadge, { ICouncilIdentityBadge } from "src/components/general/CouncilIdentity";
import { FormatNumber } from "src/components/utils/FormatNumber";

interface IProps {
  ordinal: number;
  name: string;
  year: string;
  council: ICouncil;
}

interface IState {
  debt?: number;
  dpc?: number;
}

class DebtWidget extends React.PureComponent<
IProps,
IState,
ICouncilIdentityBadge> {
  public state: IState = {};

  public componentDidMount() {
    this.generateWidget(this.props.council, this.props.year);
  }

  public componentWillReceiveProps(newProps: IProps) {
    if (newProps.year !== this.props.year) {
      this.generateWidget(newProps.council, newProps.year);
    }
  }

  public generateWidget = (council: ICouncil, year: string) => {
    axios
      .all([
        axios.get(
          `${baseUrl}/debtPerCapita?${qs.stringify({
            council: council.id,
            year
          })}`
        ),
        axios.get(
          `${baseUrl}/grossDebt?${qs.stringify({
            council: council.id,
            year
          })}`
        )
      ])
      .then(
        axios.spread((debtPerCapita, debtGross) => {
          // Need to transform this data into the right shape
          const dpc = debtPerCapita.data[0].value;
          const debt = debtGross.data[0].value;
          return { debt, dpc };
        })
      )
      .then(generatedData => {
        this.setState(generatedData);
      });
  };

  public render() {
    let size;
    size = 45;

    const debtRounded = this.state.debt
      ? Math.round(( this.state.debt / 1000 ) * 100) / 100
      : null;
    const dpcRounded = this.state.dpc
      ? FormatNumber( Math.round( ( this.state.dpc ) * 100) / 100, 2 )
      : null;

      const isOkay = this.state.debt && this.state.dpc;

    return (
      <div className="c-debt flex flex-wrap flex-col w-1/2 md:1-1/4 lg:w-1/4 items-center justify-end p-4 pt-0 mt-6">
        {isOkay ? (
          <React.Fragment>
            <div className="lg:hidden mb-4">
              <CouncilIdentityBadge
                name={ this.props.name }
                badge={ this.props.ordinal }
                modifier="justify-center"
              />
            </div>
            <img
              src={DebtSvg}
              alt="Debt"
              style={{ width: size, height: size }}
            />
            <div className="text-cct-blue font-montserrat text-xl font-bold mt-2">
              {`$${debtRounded}M`}
            </div>
          </React.Fragment>
        ) : (
          <div className="h-auto py-8 w-full flex items-center justify-center">
            <DataMissing />
          </div>
        )}
        <div className="relative">
          <div>
            {isOkay ? (
              <div className="c-debt__label">
                <div className="hidden lg:block">
                  <CouncilIdentityBadge
                    name={ this.props.name }
                    badge={ this.props.ordinal }
                    modifier="justify-center"
                  />
                </div>
                <p className="text-center lg:text-left"><span className="text-cct-blue font-bold">{`$${ dpcRounded }`}</span>{" "}
                per resident</p>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

export default DebtWidget;



// WEBPACK FOOTER //
// ./src/components/report/councilFinances/DebtWidget.tsx